import { computed, signal } from '@angular/core';
import {
    Observable
} from 'rxjs';
import { VisualDataQueryResourceManager, VisualDataResourceOptions, VisualDataTableResourceOptions } from '../../VisualDataSource';
import { ResourceImpl } from './ResourceImpl';
import { TableImpl } from './TableImpl';
import { encodeCacheKey } from 'src/app/pbir/utils/cacheKey';

export type ResourceKey = any;

export class ResourceManagerImpl implements VisualDataQueryResourceManager {
  private readonly resources = new Set<ResourceImpl<any>>(); 
  private readonly cache = new Map<string, ResourceImpl<any>>();

  constructor() { }

  readonly loadingResourceCount = signal(0);
  readonly anyLoading = computed(() => this.loadingResourceCount() > 0);
  
  getOrCreate<T>(
    table: TableImpl,
    key: ResourceKey,
    sourceFactory: (aborted?: Observable<void>) => Observable<T>,
    options?: { onAbort?: () => void; noCache?: boolean; debugName?: string; abortSignal?: Observable<void> }
  ): ResourceImpl<T> {
    let keyString = encodeCacheKey(JSON.stringify([
      table.resultSetIndex,
      key
    ]));

    let resource;

    if (options?.noCache) {
      resource = this.create(table, sourceFactory, options?.onAbort, options?.debugName, options?.abortSignal);
    }
    else {
      resource = this.cache.get(keyString);
      if (resource) {
        if (resource._aborted) {
          resource = null;
          this.cache.delete(keyString);
        }
      }

      if (!resource) {
        resource = this.create(table, sourceFactory, options?.onAbort, options?.debugName, options?.abortSignal);
        this.cache.set(keyString, resource);
      }
    }

    return resource;
  }

  private create<T>(
    table: TableImpl,
    sourceFactory: (aborted?: Observable<void>) => Observable<T>,
    onAbort?: () => void,
    debugName?: string,
    abortSignal?: Observable<void>): ResourceImpl<T> {
    let resource = new ResourceImpl<T>(table, sourceFactory, onAbort, debugName, abortSignal);
    this.resources.add(resource);
    return resource;
  }

  abortAll() {
    for (let r of [...this.resources.values()]) {
      r.abort();
    }
  }
}
